import { render, staticRenderFns } from "./question-mark.vue?vue&type=template&id=8aaca014&scoped=true&"
import script from "./question-mark.vue?vue&type=script&lang=js&"
export * from "./question-mark.vue?vue&type=script&lang=js&"
import style0 from "./question-mark.vue?vue&type=style&index=0&id=8aaca014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaca014",
  null
  
)

export default component.exports